import { useEditPointsOperations } from "./editPointsOperations.query";
import { useDeletePointsOperation } from "./deletePointsOperation.query";
export const Mutations = { useEditPointsOperations, useDeletePointsOperation };
